"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const HBIcon_1 = __importDefault(require("../components/HBIcon/HBIcon"));
function PhoneClassic16Svg(props) {
    return react_1.default.createElement("svg", Object.assign({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, props),
        react_1.default.createElement("path", { fill: "#131416", fillRule: "evenodd", d: "m3.48 0 3.285 2.186a1.872 1.872 0 0 1 .452 2.65L5.614 7.03c.093.124.206.267.339.426a19.1 19.1 0 0 0 1.129 1.229c.41.412.821.787 1.169 1.063.065.051.126.098.183.14l1.748-1.708a1.974 1.974 0 0 1 2.93.203L16 12.144 11.77 16l-.368-.024c-4.016-.262-6.754-2.16-8.68-4.322C.803 9.503 0 6.642 0 3.5v-.373L3.48 0Zm.1 2.175L1.845 3.87c.061 2.695.794 4.953 2.264 6.602C5.587 12.127 7.8 13.71 11.258 14l2.218-2.144-1.837-2.394a.104.104 0 0 0-.154-.01L8.9 11.977l-.483-.095a2.225 2.225 0 0 1-.705-.296 6.192 6.192 0 0 1-.623-.442c-.42-.334-.884-.76-1.326-1.203a21.105 21.105 0 0 1-1.238-1.349c-.347-.415-.67-.845-.846-1.19l-.248-.484L5.718 3.79a.099.099 0 0 0-.024-.14L3.579 2.176Z", clipRule: "evenodd" }));
}
function PhoneClassic16(_a) {
    var { svgProps } = _a, props = __rest(_a, ["svgProps"]);
    return react_1.default.createElement(HBIcon_1.default, Object.assign({}, props),
        react_1.default.createElement(PhoneClassic16Svg, Object.assign({}, svgProps)));
}
exports.default = PhoneClassic16;
//# sourceMappingURL=PhoneClassic16.js.map